module.exports = __webpack_public_path__ + "static/Rain-8069bfa735f3a3f8c07b3967141ab80a.jpg";